import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidenavToggleService {
  private openSidenavEmitter: EventEmitter<boolean>;
  private isOpen: boolean = false;

  constructor() {
    this.openSidenavEmitter = new EventEmitter<boolean>();
  }

  public getOpenSideNavEmitter(): EventEmitter<boolean> {
    return this.openSidenavEmitter;
  }

  public open() {
    this.isOpen = true;
    this.openSidenavEmitter.emit(this.isOpen);
  }

  public close() {
    this.isOpen = false;
    this.openSidenavEmitter.emit(this.isOpen);
  }

  public toggle() {
    this.isOpen = !this.isOpen;
    this.openSidenavEmitter.emit(this.isOpen);
  }
}
